import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const newDiscoveryCardClass = css`
  padding: 0 1rem;
`;

export const SliderWrapper = styled.div``;
